// 规则核对日期：2026-10-16。面向使用者，避免将内部实现字段作为操作步骤。
// 来源：components/libs/lcsjThemeConfig.vue、components/common/LockSettings.vue、SystemLock.vue；
// utils/theme.js、systemLock.js、costPermission.js、tableFullValue.js；
// components/libs/lcsjFilter.vue、topTab.vue；
// 后端 StoreOrderRepository、ReceiptRepository（含 OutputSafety）、ProcessOrderRepository、
// ProcessPurchaseRepository、AttendanceRepository、SalaryRepository 的状态与参数检查。
export default [
	{
		"id": "sec-theme",
		"title": "主题设置与浏览器保存规则",
		"items": [
			{
				"rule": "入口：点击页面右上角太阳或月亮图标，打开「主题设置」。浅色、深色和主题色可分别选择，默认是浅色模式与松石绿。",
				"examples": [
					"想让界面变暗，只切换「深色」即可，不必重新选择主题色。"
				]
			},
			{
				"rule": "选择外观模式、预设颜色或取色器颜色后立即生效，无需另外保存。「完成」关闭面板；关闭面板不会撤销已经生效的选择。",
				"examples": []
			},
			{
				"rule": "主题色统一用于导航、按钮、链接和选中状态。顶部与左侧导航会使用同色系的深色背景，文字和交互颜色会自动调整以便阅读，不一定与输入色值完全相同。",
				"examples": []
			},
			{
				"rule": "可使用预设色，也可输入 3 位或 6 位十六进制色值。输入后按回车、离开输入框或点击「完成」应用；无效色值会提示纠正。",
				"examples": [
					"#0e7c66 是六位色值，#abc 是三位色值；输入「绿色」不能作为色值。"
				]
			},
			{
				"rule": "主题自动保存在当前浏览器的网站存储中，刷新或下次打开会继续使用。它不是按员工账号云端同步的设置；换电脑、浏览器或访问地址后，可能需要重新设置。",
				"examples": [
					"同一浏览器里切换员工账号，可能仍看到上一个人选择的主题。"
				]
			},
			{
				"rule": "「恢复默认」只恢复默认外观和主题色，不修改订单、库存、会员余额，也不重置锁屏设置。清除网站存储可能同时清掉登录和其他本地设置，不要把清缓存当作日常换色操作。",
				"examples": []
			},
			{
				"rule": "浏览器禁止存储或存储不可用时，当前页面仍可换主题，但下次打开可能无法保留。主题变化不会改变业务状态、权限或统计金额。",
				"examples": []
			}
		],
		"tip": "主题属于当前浏览器的外观偏好；权限和业务规则由系统业务配置决定。"
	},
	{
		"id": "sec-lock",
		"title": "锁系统、临时密码与重新登录",
		"items": [
			{
				"rule": "在「主题设置」中找到「锁系统」。开启后可点「立即锁定」，或在业务界面按 Alt + L；关闭该开关后快捷锁屏不生效。",
				"examples": []
			},
			{
				"rule": "每次锁屏先设置本次密码，并再次输入确认，长度为 6–32 位。点击「确认并锁定」后才真正锁定；设置阶段可取消。它是本次锁屏密码，不是修改登录密码。",
				"examples": []
			},
			{
				"rule": "锁定后不能继续操作背后的表格、弹窗和业务快捷键。输入正确密码解锁，可回到原工作界面；本次密码随即清除，下次锁屏重新设置。",
				"examples": []
			},
			{
				"rule": "连续输错 5 次密码需等待 30 秒再试，倒计时期间不能继续提交。不要连续点击解锁。",
				"examples": []
			},
			{
				"rule": "锁屏后刷新页面，或关闭后重新进入系统，需要重新登录，不能靠刷新继续原业务。忘记本次密码可点「返回登录」，使用账号重新登录。",
				"examples": [
					"「返回登录」会清理当前登录与页面缓存，未保存的表单可能丢失；暂时离开工位前应先保存业务。"
				]
			},
			{
				"rule": "锁屏用于临时离开时保护当前界面，不等于保存表单，也不等于退出账号。主题的「恢复默认」不会解除锁屏。",
				"examples": []
			},
			{
				"rule": "系统记录锁屏操作，供有权限的管理人员查看。若提示无法保存锁屏状态，应先检查浏览器是否允许网站存储，不要把未成功锁定的页面留给他人使用。",
				"examples": []
			}
		],
		"tip": "临时离开先保存，再锁屏；交接电脑或结束工作时退出账号。"
	},
	{
		"id": "sec-query",
		"title": "通用查询、六列筛选与列表操作",
		"items": [
			{
				"rule": "列表查询条件统一按每行六列排列。默认显示首行，超过六项可点「更多筛选」展开，再点「收起筛选」折叠；收起不会清空已经填写的条件。",
				"examples": [
					"姓名藏到折叠区域后仍会参与查询。想取消它，应清空该项或点页面提供的「重置」。"
				]
			},
			{
				"rule": "多个已填写条件共同限制结果。部分下拉框选择后会立即查询；为确保文本和日期条件已生效，填完后点击「搜索」。有回车查询的文本框也可按回车。",
				"examples": []
			},
			{
				"rule": "「全部」表示不按该项细分，不等于获得跨门店或额外数据权限。「重置」恢复该页面的初始查询值，初始值可能包含门店、状态或日期。",
				"examples": []
			},
			{
				"rule": "加工部订单首行依次为所属门店、顾客姓名、顾客电话、订单编号、加工类型、订单状态。其余条件在展开区域；加工类型与加工渠道是不同维度。",
				"examples": []
			},
			{
				"rule": "日期区间要同时核对开始和结束日期，以及筛选字段的业务含义。下单日期、取镜日期、审核时间、入库时间不是同一个时间。",
				"examples": []
			},
			{
				"rule": "筛选展开后，列表区域可以滚动，分页保持在底部。列较多时使用表格底部横向滚动条；不要只凭当前屏幕中可见的列判断数据缺失。",
				"examples": []
			},
			{
				"rule": "门店名称列至少容纳四个汉字，较长名称按内容扩宽；加工类型的标签、业务编号和日期时间也有完整展示规则。其他长文本可通过详情或页面提供的悬浮提示查看。",
				"examples": []
			},
			{
				"rule": "分页总数是当前查询范围内的记录数，不是当前页条数。批量处理前核对勾选记录、门店和状态；切换页码或筛选后再次检查选择结果，不要假定所有列表都会跨页保留勾选。",
				"examples": []
			}
		],
		"tip": "查不到数据时先核对门店、日期、状态和折叠区域中的条件，再确认账号权限。"
	},
	{
		"id": "sec-access",
		"title": "账号、数据范围与操作权限",
		"items": [
			{
				"rule": "菜单可见、按钮可用和单据当前能否操作是不同条件。即使看得到列表，确认、审核、删除、导出、回退等操作仍可能需要单独授权，并受单据状态限制。",
				"examples": [
					"没有「回退出库」按钮时，先联系管理员核对权限；修改主题或查询条件不会增加权限。"
				]
			},
			{
				"rule": "数据范围与当前账号、所属门店及管理员配置有关。同一查询条件在不同账号下可能得到不同结果。不要将自己的「全部」理解成全公司全部记录。",
				"examples": []
			},
			{
				"rule": "成本类信息按角色配置显示。无查看权限时，成本相关列可能隐藏；重新进入页面或打开详情时会重新读取配置。不要把隐藏的成本列当作成本为零。",
				"examples": []
			},
			{
				"rule": "登录失效或切换账号后，应重新进入业务页面，核对当前姓名、门店及查询条件。共享电脑上的主题设置可能延续，但业务操作应始终使用本人账号。",
				"examples": []
			},
			{
				"rule": "操作被拒绝时，先看提示中的单号、状态和权限原因；保留业务单号交由有权限的人员处理，不要通过重复新建单据来绕过限制。",
				"examples": []
			}
		],
		"tip": "权限调整由管理员负责；日常用户应核对当前身份和门店后再处理业务。"
	},
	{
		"id": "sec-store-processing",
		"title": "门店订单与加工部订单的流转",
		"items": [
			{
				"rule": "「门店订单」与「加工部订单」用于门店配镜订单的不同处理视角，不能套用销售订单的会员卡扣款规则。查同一业务时优先使用订单编号核对。",
				"examples": []
			},
			{
				"rule": "确认只允许处理待确认订单。批量确认前逐项检查状态；已经确认的记录不能再次确认。",
				"examples": []
			},
			{
				"rule": "门店快递单号只允许在「门店待邮寄」状态录入；加工部快递单号只允许在「加工中」状态录入。两种快递单号分别对应寄出和寄回环节。",
				"examples": [
					"订单还没开始加工时，不能通过录入加工部快递单号提前结束流程。"
				]
			},
			{
				"rule": "审核受当前状态和审核方式约束。库存审核会检查商品库存；库存不足时可能生成采购单，需完成相应采购、入库环节，不要重复审核制造重复采购。",
				"examples": []
			},
			{
				"rule": "订单完成操作要求状态为「加工部快递中」。录入快递单号与完成订单是两个步骤，完成前应核对实际业务进度。",
				"examples": []
			},
			{
				"rule": "加工类型描述此次加工内容，例如新加工镜片、更换镜架；加工渠道描述由哪个渠道加工。筛选更换镜架应使用「加工类型」，不要用加工渠道代替。",
				"examples": []
			},
			{
				"rule": "预警和超期与取镜日期及系统配置有关。待处理列表中的提醒用于追踪交付，不代表订单已经完成；查看详情和流转记录确认实际进度。",
				"examples": []
			}
		],
		"tip": "状态不允许操作时，先刷新并检查上一环节是否完成。"
	},
	{
		"id": "sec-process-order",
		// 独立门店加工管理暂不对外展示，保留说明供后续恢复。
		"hidden": true,
		"title": "独立加工订单、补货与完成规则",
		"items": [
			{
				"rule": "独立「加工订单」使用需求门店、顾客、取单日期及左右眼商品明细。加工明细必须两条，一条右眼、一条左眼，不能重复同一眼别；商品数量必须大于零，轴位在 0–180 范围内。",
				"examples": []
			},
			{
				"rule": "这类订单的「加工类型」为门店加工、丹阳加工，与门店订单中「新加工镜片／更换镜架」的加工类型含义不同。查看字段时要先确认自己所在模块。",
				"examples": []
			},
			{
				"rule": "待确认和已退回订单可编辑；删除仅允许待确认状态。确认前检查左右眼、商品、门店和取单日期，避免后续返工。",
				"examples": []
			},
			{
				"rule": "确认后，门店加工进入「待加工」并继续出库加工流程；丹阳加工确认后直接完成。不要把两类订单都当成同一条加工路径。",
				"examples": []
			},
			{
				"rule": "缺货时通过补货生成采购单。已有未入库采购单的商品要先处理原采购单；没有库存缺口时不需要生成采购单。采购完成入库后订单回到待加工。",
				"examples": []
			},
			{
				"rule": "采购导出前要选择供应商；已入库的采购单不允许再次导出采购。商品、供应商或数量错误时先按当前状态允许的操作修正。",
				"examples": []
			},
			{
				"rule": "退回仅允许待确认或待加工状态，并且不能已经出库，也不能有未入库采购单。撤单也受状态和有效出库单限制；存在有效出库记录时先处理对应出库业务。",
				"examples": []
			},
			{
				"rule": "只有「加工中」的订单才能执行完成。订单确认、商品出库与加工完成分别代表不同节点，不能用其中一步替代其他步骤。",
				"examples": []
			}
		],
		"tip": "本节只适用于独立加工订单模块；门店订单的加工部快递与完成规则见上一节。"
	},
	{
		"id": "sec-stock",
		"title": "入库、出库、防重与出库回退",
		"items": [
			{
				"rule": "入库单须有单号和商品明细，单号不能重复。已经入库的单据不能修改、不能重复入库，已审核单据不能删除。保存入库单与实际执行入库要区分。",
				"examples": []
			},
			{
				"rule": "门店订单创建出库单前要通过审核，并检查商品库存。库存不足或找不到库存记录时不能强行出库，应先核对商品、采购和入库情况。",
				"examples": []
			},
			{
				"rule": "同一次出库操作重复提交时，系统会识别原请求，避免再次扣库存。遇到网络中断或结果不明确时，先查询出库记录和订单状态，按页面提示重试，不要立即再建一张出库单。",
				"examples": []
			},
			{
				"rule": "提示「订单状态已变化」说明页面上的状态与服务器已不一致。先刷新、核对其他人员是否已处理，再决定下一步。",
				"examples": []
			},
			{
				"rule": "更换镜架允许不消耗商品，出库数量可以为 0，但不能为负；其他加工类型的出库数量必须大于 0。库存数据仍须有效，不是填 0 就能绕过库存记录检查。",
				"examples": []
			},
			{
				"rule": "「回退出库」需要单独权限，按选中的出库单返还库存，并将该出库单标记为已退回；它不修改关联订单状态。",
				"examples": [
					"出库单回退后，不能认为订单自动回到了待审核或待加工。应另行核对订单下一步允许的操作。"
				]
			},
			{
				"rule": "已经退回的出库单再次操作，不会重复增加库存。若出库明细数量异常、库存记录不存在或不唯一，系统会拒绝回退，需要先核对数据。",
				"examples": []
			},
			{
				"rule": "再次出库属于新的业务操作，与原出库请求的重试不同。只有确有再次发料需求且状态允许时才使用，操作前核对原出库、已退回记录及本次商品数量。",
				"examples": []
			},
			{
				"rule": "出库和回退会留下库存变动记录，回退也有操作记录。核对差异时同时看原数量、现数量、出库单号、操作时间及人员，不能只看订单当前状态。",
				"examples": []
			}
		],
		"tip": "回退库存、撤单和销售退单是不同业务，必须在对应模块按实际情况处理。"
	},
	{
		"id": "sec-attendance-salary",
		"title": "考勤与基础薪资录入",
		"items": [
			{
				"rule": "打卡必须选择有效员工；配置为无需打卡的员工会收到相应提示。短时间重复打卡会被拦截，按提示等待后再处理，不要连续点击。",
				"examples": []
			},
			{
				"rule": "考勤统计需要选择正确年月。查错月份时，不能直接把「暂无数据」当作缺勤，应先核对员工与统计范围。",
				"examples": []
			},
			{
				"rule": "基础薪资中的员工必须与所属门店匹配，同一员工不能重复创建基础薪资。调店后录入前先核对人员档案。",
				"examples": []
			},
			{
				"rule": "基础薪资、岗位工资、社保补贴、工龄奖及应出勤天数不能小于 0。薪资配置与实际发薪记录不是同一个环节，保存配置后仍应核对相应月份的工资数据。",
				"examples": []
			}
		],
		"tip": "本节说明系统录入限制，具体考勤和工资标准以门店实际制度及系统配置为准。"
	},
	{
		"id": "sec-operation-check",
		"title": "日常核对、异常处理与反馈",
		"items": [
			{
				"rule": "操作前核对账号、门店、业务单号、商品和数量；提交后确认成功提示、列表状态与关联记录。金额、库存或状态异常时，保留单号再反馈。",
				"examples": []
			},
			{
				"rule": "批量操作不要只看总提示。页面列出未处理、未调拨或未发放明细时，逐条核对原因；某些业务允许部分成功，不能直接对整批重新执行。",
				"examples": []
			},
			{
				"rule": "查不到记录时先重置查询并核对时间口径，仍找不到再检查数据权限和单据状态。请勿通过新建相同业务来测试原单是否保存。",
				"examples": []
			},
			{
				"rule": "导出前核对当前查询、勾选范围和导出按钮用途。有的导出针对勾选记录，有的针对查询结果，不能假定只导出当前页；导出后核对文件行数与合计。",
				"examples": []
			},
			{
				"rule": "核对金额时区分订单金额、实际收款、欠款、卡销、赠送和退款；不同报表的时间口径与金额口径不同，应先统一门店、日期及业务范围。",
				"examples": []
			},
			{
				"rule": "反馈问题时提供页面名称、业务单号、操作时间、操作步骤及完整提示截图。不要提供登录密码或锁屏密码；顾客电话等信息按工作需要提供。",
				"examples": []
			}
		],
		"tip": "先确认事实，再处理业务。不要通过修改金额、数量或重复建单来绕过系统校验。"
	}
];
